module.exports = __webpack_public_path__ + "img/photo-life-studio.ca9a3d4c.png";